<div class="container-fluid">
  
    <div class="w-450px">
        <iui-messages #message  class="ms-auto me-auto"></iui-messages>
    </div>
    <div>
        <h5 id="headerLabel"> No new data will be available for this report after 10/15/2024</h5>
        <br>
    </div>
    <div class="row mb-4">
        <div class="col-2">
            <div class="row">
                <p-radioButton name="shortCodeOrFormId" id="shortCodeOrFormId" [(ngModel)]="shortCodeOrFormId" 
                value="1" label="Short Code">
                </p-radioButton>
            </div>
            <div class="row">
                <div class="col-9">
                    <div class="ps-2">
                        <input appAlphaNumOnly placeholder="Short Code" type="text" id="shortCode" class="form-control form-text" [(ngModel)]="filter.shortCode" maxlength="{{MaxLen.ShortCode}}"   [disabled] = "shortCodeOrFormId === '2'"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-2">
            <div class="row">
                <p-radioButton name="shortCodeOrFormId" id="shortCodeOrFormId" [(ngModel)]="shortCodeOrFormId" 
                value="2" label="Form ID">
                </p-radioButton>
            </div>
            <div class="row" >
                <div class="col-9">
                    <div class="ps-2">
                    <input placeholder="Form ID" type="text" id="formId" class="form-control form-text" [(ngModel)]="filter.formId" maxlength="20" [disabled] = "shortCodeOrFormId === '1'"/>
                    </div>
                </div>
                
            </div>
        </div>

    </div>
    <h5>Date Range</h5>
    <div class="row mb-4">
        <div class="col-2">
            <label for="startDate">
                Start
                <div>
                    <p-calendar [disabled] = "shortCodeOrFormId === '2'" placeholder="Start Date" [showIcon]="true" inputId="startDate" [(ngModel)]="filter.startDate" [maxDate]="today" dateFormat="yy-mm-dd"></p-calendar>
                </div>
            </label>
        </div>
        <div class="col-2">
            <label for="endDate">End
                <div>
                    <p-calendar placeholder="End Date" [showIcon]="true" inputId="endDate" [(ngModel)]="filter.endDate" [maxDate]="today" dateFormat="yy-mm-dd" [disabled]="(!filter.startDate && shortCodeOrFormId === '1' )|| shortCodeOrFormId === '2'"></p-calendar>
                </div>
            </label>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-2">
            <label for="statusType">Status Type</label>
            <p-multiSelect [disabled] = "shortCodeOrFormId === '2'" [options]="statuses" id="statusType" appTid class="p-formcontrol" [(ngModel)]="filter.status" selectedItemsLabel="{0} items selected" [maxSelectedLabels]="2" placeholder="Nothing Selected" optionLabel="name" optionValue="name" appendTo="body">
                <ng-template let-status pTemplate="item">
                    <div [ngSwitch]="status.id">
                        <span *ngSwitchDefault>{{status.name}}</span>
                    </div>
                </ng-template>
            </p-multiSelect>
        </div>
        <div class="col-2">
            <label for="auditTypes">Audit Type</label>
            <p-multiSelect [disabled] = "shortCodeOrFormId === '2'" [options]="auditTypes" appendTo="body" id="auditType" appTid class="p-formcontrol" [(ngModel)]="filter.auditType" selectedItemsLabel="{0} items selected" [maxSelectedLabels]="2"  placeholder="Nothing Selected" optionLabel="name" optionValue="name">
                <ng-template let-auditType pTemplate="item">
                    <div [ngSwitch]="auditType.id">
                        <span *ngSwitchDefault>{{auditType.name}}</span>
                    </div>
                </ng-template>
            </p-multiSelect>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-12">
            <button type="button" class="btn btn-primary" (click)="onSubmit()">Get Report</button>
            <button type="button" class="btn btn-secondary ms-3" (click)="onReset()">Reset Query</button>
        </div>
    </div>

    <div class="row" *ngIf="showData">
        <div class="col-12">
            <h5  *ngIf="results.length">Results</h5>
            <p-table 
               styleClass="p-datatable-striped" 
                #MarketMonitoring
                [columns]="tableColumn" 
                [value]="results"
                [paginator]="true"
                [rows]="rowsInPage"
                [alwaysShowPaginator]="false"
                [scrollable]="true" scrollHeight="50vh"
               currentPageReportTemplate="(Displaying {first} to {last} of {totalRecords})"
               [showCurrentPageReport]="true"
              [lazy]="true" [totalRecords]='totalRecords'  (onPage)="paginateReports($event)">
            <ng-template pTemplate="header" let-columns>
                <tr *ngIf="results.length > 0">
                    <ng-container *ngFor="let col of columns">
                        <th *ngIf="!col.sort">{{col.header}}</th>
                        <th *ngIf="col.sort" class="noBorder" [style.width.%]="col.width" [pSortableColumn]="col.field" >
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" >
                <tr>
                    <td *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field">
                        <div *ngSwitchCase="'formId'">
                            <a *ngIf="rowData.fileName" href="javascript:void(0)" (click)="downloadReport(rowData)">{{rowData[col.field]}}</a>
                            <span *ngIf="!rowData.fileName">{{rowData[col.field]}}</span>
                        </div>
                        <div *ngSwitchCase="'shortCode'">
                            <a href="javascript:void(0)" (click)="openLookup(rowData)">{{rowData[col.field]}}</a>
                        </div>
                        <div *ngSwitchDefault class="ellipsis">{{rowData[col.field]}}</div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td [attr.colspan]="columns.length" class="noBorder">
                        <b>No Records found.</b>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
